'use client'

import PropTypes from 'prop-types'
import MUIStack from '@mui/material/Stack'

export const WizardFormSection = ({ children, sx }) => {
  return (
    <MUIStack direction="row" gap="16px" data-testid="WizardFormSection" flexWrap="wrap" sx={{ ...sx }}>
      {children}
    </MUIStack>
  )
}

WizardFormSection.propTypes = {
  children: PropTypes.node,
  sx: PropTypes.object
}
